import React from 'react';

const Spinner = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        style={{ maxWidth: '30px', maxHeight: '30px', width: '100%', height: '100%' }}
    >
        <defs>
            <linearGradient id="a7">
                <stop offset="0" stopColor="#141A12" stopOpacity="0" />
                <stop offset="1" stopColor="#141A12" />
            </linearGradient>
        </defs>
        <circle
            fill="none"
            stroke="url(#a7)"
            strokeWidth="30"
            strokeLinecap="round"
            strokeDasharray="0 44 0 44 0 44 0 44 0 360"
            cx="100"
            cy="100"
            r="70"
            style={{ transformOrigin: 'center' }}
        >
            <animateTransform
                type="rotate"
                attributeName="transform"
                calcMode="discrete"
                dur="2s"
                values="360;324;288;252;216;180;144;108;72;36"
                repeatCount="indefinite"
            />
        </circle>
    </svg>
);

export default Spinner;
